export default "/_next/static/images/9dcc30574935a5bfb2e35aa534fd7eee.svg";